import { DICOM_CONNECTION_FIELDS, FIELD_TYPES, toBool } from '../Interfaces.shared';

const DEFAULT_INTERVAL_SECONDS = 21600; // 6 hours

const normalizeDailyTime = (value) => {
  if (!value) return '6:00';
  const match = String(value).match(/^(\d{1,2}):(\d{2})/);
  if (!match) return '6:00';
  return `${parseInt(match[1], 10)}:${match[2]}`;
};

export const WORKLIST_INTERFACE_TYPES = {
  worklist: {
    id: 'worklist',
    titleKey: 'Settings.worklist_servers',
    dialogTitleKey: 'Settings.worklist_server_config',
    dialogSubtitleKey: 'Settings.worklist_server_config_subtitle',
    endpoint: 'worklist_nodes',
    detailsRenderer: 'worklist',
    emptyNode: {
      name: '',
      ip: '',
      aet: '',
      port: '',
      modality: '',
      scheduled_station_aet: '',
      caller_aet: '',
      is_active: 1,
      mode: 'interval',
      daily_time: '6:00',
      interval_seconds: DEFAULT_INTERVAL_SECONDS,
      timespan_days: 1,
    },
    fields: [
      ...DICOM_CONNECTION_FIELDS,
      {
        key: 'modality',
        labelKey: 'Settings.modality',
        type: FIELD_TYPES.TEXT,
        required: false,
      },
      {
        key: 'scheduled_station_aet',
        labelKey: 'Settings.scheduled_station_aet',
        type: FIELD_TYPES.TEXT,
        required: false,
      },
      {
        key: 'caller_aet',
        labelKey: 'Settings.caller_aet',
        type: FIELD_TYPES.TEXT,
        required: false,
        placeholderFrom: 'dicom_server_aet',
      },
      {
        key: 'is_active',
        labelKey: 'Settings.worklist_query_enabled',
        type: FIELD_TYPES.BOOLEAN,
        required: false,
      },
      {
        key: 'mode',
        labelKey: 'Settings.worklist_fetch_mode',
        descriptionKey: 'Settings.worklist_fetch_mode_description',
        type: FIELD_TYPES.SELECT,
        required: false,
        renderAs: 'toggle',
        options: [
          { value: 'daily', labelKey: 'Settings.worklist_fetch_daily' },
          { value: 'interval', labelKey: 'Settings.worklist_fetch_interval' },
        ],
      },
      {
        key: 'daily_time',
        labelKey: 'Settings.worklist_daily_fetch_hour',
        type: FIELD_TYPES.SELECT,
        required: false,
        showWhen: { key: 'mode', value: 'daily' },
        options: [
          { value: '6:00', labelKey: '6:00' },
          { value: '7:00', labelKey: '7:00' },
          { value: '8:00', labelKey: '8:00' },
          { value: '9:00', labelKey: '9:00' },
          { value: '10:00', labelKey: '10:00' },
          { value: '11:00', labelKey: '11:00' },
          { value: '12:00', labelKey: '12:00' },
          { value: '13:00', labelKey: '13:00' },
          { value: '14:00', labelKey: '14:00' },
          { value: '15:00', labelKey: '15:00' },
          { value: '16:00', labelKey: '16:00' },
          { value: '17:00', labelKey: '17:00' },
        ],
      },
      {
        key: 'interval_seconds',
        labelKey: 'Settings.worklist_query_interval',
        type: FIELD_TYPES.SELECT,
        required: false,
        showWhen: { key: 'mode', value: 'interval' },
        options: [
          { value: 7200, labelKey: 'Settings.worklist_interval_2h' },
          { value: 14400, labelKey: 'Settings.worklist_interval_4h' },
          { value: 21600, labelKey: 'Settings.worklist_interval_6h' },
          { value: 43200, labelKey: 'Settings.worklist_interval_12h' },
          { value: 86400, labelKey: 'Settings.worklist_interval_24h' },
        ],
      },
      {
        key: 'timespan_days',
        labelKey: 'Settings.worklist_timespan',
        descriptionKey: 'Settings.worklist_timespan_description',
        type: FIELD_TYPES.SELECT,
        required: false,
        options: [
          { value: 1, labelKey: 'Settings.worklist_timespan_1d' },
          { value: 2, labelKey: 'Settings.worklist_timespan_2d' },
          { value: 3, labelKey: 'Settings.worklist_timespan_3d' },
        ],
      },
    ],
    headerToggles: ['is_active'],
    displayFields: ['name', 'aet', 'ip', 'port'],
    testEndpoint: (name) => `worklist_echo/${name}`,
    testMethod: 'GET',
    hasTest: true,
    preparePayload: (payload, form) => {
      const mode = form.mode || 'interval';
      payload.mode = mode;

      if (mode === 'daily') {
        delete payload.interval_seconds;
        if (payload.daily_time && !/:\d{2}:\d{2}$/.test(payload.daily_time)) {
          payload.daily_time = `${payload.daily_time}:00`;
        }
      } else {
        delete payload.daily_time;
      }

      return payload;
    },
    normalize: (s) => {
      const hasDaily = s.daily_time !== undefined && s.daily_time !== null && s.daily_time !== '';
      const hasInterval =
        s.interval_seconds !== undefined && s.interval_seconds !== null && s.interval_seconds !== '';

      const mode = s.mode || (hasDaily && !hasInterval ? 'daily' : 'interval');

      return {
        name: s.Name || s.name,
        ip: s.IP || s.ip,
        aet: s.AET || s.aet,
        port: s.Port || s.port,
        modality: s.modality || '',
        scheduled_station_aet: s.scheduled_station_aet || '',
        caller_aet: s.caller_aet || '',
        is_active: toBool(s.is_active, true),
        mode,
        daily_time: normalizeDailyTime(s.daily_time),
        interval_seconds:
          s.interval_seconds !== undefined ? Number(s.interval_seconds) : DEFAULT_INTERVAL_SECONDS,
        timespan_days: s.timespan_days !== undefined ? Number(s.timespan_days) : 1,
      };
    },
  },
};

export const WORKLIST_COLLECTIONS = [
  {
    id: 'worklist',
    titleKey: 'Settings.worklist_servers',
    typeIds: ['worklist'],
    defaultTypeId: 'worklist',
    emptyMessageKey: 'Settings.no_worklist_servers_found',
  },
];
